import { Modal, Button } from "react-bootstrap";
import "./Contact.css";

const Contact = ({ show, handleClose }) => {
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="modal-title-custom">Contact Us</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="contact-form">
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control styled-input"
                id="name"
                placeholder="Enter your name"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="contact" className="form-label">
                Contact Number
              </label>
              <input
                type="text"
                className="form-control styled-input"
                id="contact"
                placeholder="Enter your contact number"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="pincode" className="form-label">
                Pin Code
              </label>
              <input
                type="text"
                className="form-control styled-input"
                id="pincode"
                placeholder="Enter your pin code"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="city" className="form-label">
                City
              </label>
              <input
                type="text"
                className="form-control styled-input"
                id="city"
                placeholder="Enter your city"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="state" className="form-label">
                State
              </label>
              <input
                type="text"
                className="form-control styled-input"
                id="state"
                placeholder="Enter your state"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="message" className="form-label">
                Message
              </label>
              <textarea
                className="form-control styled-input"
                id="message"
                rows="4"
                placeholder="Write your message here"
              ></textarea>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="styled-button"
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleClose}
            className="styled-button"
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Contact;
